import Vue from 'vue'
import store from './store'
import VueCompositionAPI from '@vue/composition-api'
import { getAttributeValue } from "@/shared/filters/utils-filter"
import StudentExchangeInformationColumnWidget
    from "@/apps/StudentExchangeInformationColumnWidget/StudentExchangeInformationColumnWidget.vue";

Vue.config.productionTip = false
Vue.use(VueCompositionAPI)

let widgetEls = document.querySelectorAll('student-exchange-information-column-widget')
if (widgetEls.length) {
    widgetEls.forEach(el => {
        new Vue({
            el: el,
            store,
            render(h: any) {
                return h(StudentExchangeInformationColumnWidget, {
                    props: {
                        labels: getAttributeValue(el, 'labels', true),
                    }
                })
            }
        })
    })
}
